<template>
  <el-form
    :model="usuarioAutenticacao"
    class="login-form"
    @submit.prevent="submit"
  >
    <el-form-item>
      <template #label> CPF <span>(passport)</span> </template>
      <input-cpf-passaporte
        v-model="usuarioAutenticacao.login"
        class="input-login"
        :placeholder="i18n.conta.login.digiteSeuCpfPassaporte"
        autocomplete="username"
      />
    </el-form-item>
    <el-form-item>
      <template #label> Senha <span>(password)</span> </template>
      <el-input
        class="input-login"
        v-model="usuarioAutenticacao.senha"
        type="password"
        :placeholder="i18n.conta.login.digiteSuaSenha"
      />
    </el-form-item>
    <el-form-item style="margin-top: 25px">
      <el-button
        class="big-button green-filled"
        type="primary"
        @click="submit"
        block
        >{{ i18n.conta.login.login }}</el-button
      >
    </el-form-item>
    <el-form-item>
      <el-button class="el-button big-button green-border" @click="cadastrar"
        >{{ i18n.conta.login.cadastrar }}
      </el-button>
    </el-form-item>
    <el-row class="form-links">
      <el-button
        type="text"
        class="green-link"
        @click="handleOpenModalConfirmacaoEmail"
        >{{ i18n.conta.login.naoRecebiEmail }}</el-button
      >
      <el-button
        type="text"
        class="green-link"
        @click="handleOpenModalRedefinicaoSenha"
        >{{ i18n.conta.login.esqueciSenha }}</el-button
      >
    </el-row>
    <solicitacao-cpf-passaporte-modal
      v-if="modalProps.visible"
      :fluxo="modalProps.fluxo"
      v-model="modalProps.input"
      :visible.sync="modalProps.visible"
      @confirm="handleModalContaConfirm"
    />
  </el-form>
</template>

<script>
import LoginService from "@/services/LoginService.js";
import { setAccessToken } from "@/utils/Autenticacao.js";
import { buildErrorNotifyPayload } from "@/services/shared/handling/apiErrorNotification";
import SolicitacaoCpfPassaporteModal from "@/components/modals/SolicitacaoCpfPassaporteModal.vue";
import InputCpfPassaporte from "@/components/common/InputCpfPassaporte.vue";
import "@/utils/helpers/formatacao";

export default {
  name: "LoginForm",
  components: {
    SolicitacaoCpfPassaporteModal,
    InputCpfPassaporte
  },
  data() {
    return {
      usuarioAutenticacao: {
        login: "",
        senha: ""
      },
      contextPath: process.env.VUE_APP_CONTEXT_PATH || "/",
      modalProps: {
        fluxo: "",
        visible: false,
        input: ""
      }
    };
  },
  computed: {
    i18n() {
      return this.$i18n.messages[this.$i18n.locale].interface;
    },
    isPortuguese() {
      return this.$i18n.locale === "PT-BR";
    }
  },
  mounted() {
    if (this.$route.query.redefinirSenha === "true") {
      this.handleOpenModalRedefinicaoSenha();
    }
  },
  methods: {
    submit() {
      if (this.usuarioAutenticacao.login && this.usuarioAutenticacao.senha) {
        let loginFormatado = String(this.usuarioAutenticacao.login).trim();
        if (loginFormatado.isCPF()) {
          loginFormatado = loginFormatado.replace(/\D/g, "");
        } else {
          loginFormatado = loginFormatado.toUpperCase();
        }
        LoginService.logar({
          login: loginFormatado,
          senha: this.usuarioAutenticacao.senha
        })
          .then(response => {
            if (response.status === 200 && response.data.token) {
              setAccessToken(response.data.token);
              this.$router.push("/");
            }
          })
          .catch(error => {
            this.$notify(buildErrorNotifyPayload(this.$createElement, error));
          });
      }
    },
    cadastrar() {
      const query = {};

      if (!this.isPortuguese) {
        query.foreign = true;
      }

      this.$router.push({ path: "/cadastro-usuario", query });
    },
    handleOpenModalConfirmacaoEmail() {
      this.modalProps.fluxo = "emailConfirmacao";
      this.modalProps.visible = true;
    },
    handleOpenModalRedefinicaoSenha() {
      this.modalProps.fluxo = "redefinicaoSenha";
      this.modalProps.visible = true;
    },
    clearModal() {
      this.modalProps.fluxo = "";
      this.modalProps.input = "";
      this.modalProps.visible = false;
    },
    handleModalContaConfirm({ fluxo, identificador }) {
      const fluxoSolicitacao = {
        emailConfirmacao: LoginService.solicitarConfirmacaoEmail,
        redefinicaoSenha: LoginService.solicitarRedefinicaoSenha
      };

      fluxoSolicitacao[fluxo](identificador)
        .then(() => {
          const h = this.$createElement;

          this.$notify({
            title: this.i18n.geral.sucesso,
            message: h(
              "i",
              {
                style: {
                  color: "#295661",
                  display: "block",
                  fontStyle: "normal",
                  textAlign: "left"
                }
              },
              this.i18n.conta.envioEmail.sucesso
            ),
            type: "success"
          });
          this.clearModal();
        })
        .catch(error => {
          this.$notify(
            buildErrorNotifyPayload(
              this.$createElement,
              error,
              this.i18n.conta[fluxo].modal.error
            )
          );
        });
    }
  }
};
</script>

<style>
.input-login input.el-input__inner {
  border-radius: 8px !important;
  border: 1px solid #bebebe;
  background: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.el-form-item__label {
  color: #383838;
  font-family: Nunito;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>

<style scoped>
.login-form {
  max-width: 400px;
  margin: 0 auto;
}

.form-links {
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  row-gap: 2px;
}

.form-links .green-link {
  padding: 2px 4px !important;
  margin: 0 !important;
  line-height: 1.3;
}

.el-form-item__label span {
  color: #9f9f9f;
}
</style>
